import { API_URL } from "../api";

// The Store as the ops API sends it (routes/v1OpsStore.ts).

export type StoreCategory = { key: string; en: string; bn: string };
export type StoreMeta = { categories: StoreCategory[]; csvTemplate: string };

export type OpsProduct = {
  id: number;
  sku: string;
  name: string;
  nameBn: string;
  brand: string;
  category: string;
  subcategory: string;
  packLabel: string;
  groupKey: string | null;
  description: string;
  descriptionBn: string;
  pricePaisa: number;
  mrpPaisa: number | null;
  inStock: boolean;
  active: boolean;
  featured: boolean;
  rxRequired: boolean;
  sort: number;
  medicineId: number | null;
  imageFile: string | null;
  imageUrl: string | null;
  updatedAt: string;
};

export type ProductPage = { products: OpsProduct[]; total: number; page: number; pages: number; counts: { all: number; withPhoto: number } };
export type ProductKey = { id: number; sku: string; imageFile: string | null; hasImage: boolean };
export type ImportResult = { created: number; updated: number; errors: string[]; notes: string[]; dryRun: boolean };

export type OpsBanner = {
  id: number;
  imageUrl: string;
  width: number | null;
  height: number | null;
  link: { type: string; value: string | null };
  altText: string;
  linkType: string;
  linkValue: string | null;
  position: number;
  active: boolean;
  startsAt: string | null;
  endsAt: string | null;
};

/** Store images are served by the public API (/api/store/...), next to /api/v1. */
export const imageSrc = (path: string | null) => (path ? API_URL.replace(/\/api\/v1\/?$/, "") + path : null);
